import { render, staticRenderFns } from "./ViewPromotions.vue?vue&type=template&id=1cd0f9ea&scoped=true&"
import script from "./ViewPromotions.vue?vue&type=script&lang=js&"
export * from "./ViewPromotions.vue?vue&type=script&lang=js&"
import style0 from "./ViewPromotions.vue?vue&type=style&index=0&id=1cd0f9ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd0f9ea",
  null
  
)

export default component.exports